import * as React from 'react';

import {CTABannerWithButtons} from 'shells/cta-banner/cta-banner-with-buttons';
// @ts-expect-error - imported from .js/.jsx file
import {HourglassHalfIcon} from 'shells/icon/svg/hourglass-half-icon';

type Props = {
    canAccessBilling?: boolean;
};

export function LandingPagesUpsellBanner(props: Props) {
    return (
        <div className='my-16'>
            <CTABannerWithButtons
                icon={HourglassHalfIcon}
                title='You’re currently exploring a preview version of Nutshell’s Landing pages'
                text='Upgrade to enjoy the full experience and remove the banner ad from your published pages'
                primaryCTA={
                    props.canAccessBilling
                        ? {
                              text: 'View billing',
                              href: '/setup/billing/sales',
                              isRoutedLink: true,
                              newTab: true,
                          }
                        : undefined
                }
            />
        </div>
    );
}
